import { DependencyInjectionContainer } from "./dependency-injection-container";
import { Logger } from "@src/cloud-connect/logger/logger";

const loggerKey = "logger";

export const getLogger = () => {
  return DependencyInjectionContainer.getInstance().resolve<Logger>(loggerKey);
};

export const registerLogger = () => {
  DependencyInjectionContainer.getInstance().register(loggerKey, Logger);
};
